import * as React from 'react';
export var defaultLegacyConfig = {
  showBannerControls: true
};
export var LegacyConfigContext = React.createContext(defaultLegacyConfig);
export var LegacyConfigProvider = LegacyConfigContext.Provider;
export var useLegacyConfig = function () {
  return React.useContext(LegacyConfigContext);
};